import { render, staticRenderFns } from "./OrderFilters.vue?vue&type=template&id=50a63c0b&scoped=true"
import script from "./OrderFilters.vue?vue&type=script&lang=js"
export * from "./OrderFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a63c0b",
  null
  
)

export default component.exports